
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ShapeType } from '@/ui-kit/components/icon-button/enums';
import ListingAction from '@/components/listing-card/action';

export default {
  name: 'ListingGalleryActions',
  components: {
    ListingAction,
  },
  props: {
    galleryTitledActions: {
      default: null,
      type: Array,
    },
    listingActions: {
      default: null,
      type: Array,
    },
    listing: {
      required: true,
      type: Object,
    },
    size: {
      default: StyleSizeType.Medium,
      type: String,
    },
    shape: {
      default: ShapeType.Rounded,
      type: String,
    },
  },
  data() {
    return {
      ButtonFillType,
      StyleSizeType,
      StyleColorSchemeType,
      ShapeType,
    };
  },
};
